import { AppConfigRunTimeEnv } from "../config/config.ts";

export function hasFeatureEnabled(feature: string): boolean {
  const features = readEnv("ACTIVE_FEATURES", "").replace(/ +/g, "").split(",");
  return features.includes(feature);
}

export function readEnv(key: keyof AppConfigRunTimeEnv, fallback: string) {
  if (typeof window === "undefined") return fallback;
  let config = "";

  if ("__RUNTIME_CONFIG__" in window && key in window.__RUNTIME_CONFIG__) {
    // MF: uncomment to enable ModuleFederation
    // This is not pretty but was necessary to get the Single SPA Admintool running.
    config = (window.__RUNTIME_CONFIG__ as AppConfigRunTimeEnv)[key];
  }

  if (!config && fallback) return fallback;
  return config;
}
